import moment from "moment";
import { Link } from "react-router-dom";
import { Copy, Remove } from "../../../assets/icons";
import IconDropdown from "../../../components/common/IconDropdown";

interface IDocumentProjects {
    handleDropdown: (
        selectedValue: string,
        record: { [key: string]: string | boolean | number | undefined }
    ) => void;
    iconDropdownOptions?: any;
    handleNavigate?: any;
}

interface IDocumentProjectsCustomer {
    handleNavigate?: any;
}

export const DocumentProjects = ({
    handleDropdown,
    iconDropdownOptions,
    handleNavigate,
}: IDocumentProjects) => [
        {
            title: "Project name",
            dataIndex: "ProjectName",
            key: "projectName",
            sortable: true,
            width: "11.25%",
            render: (_: string, record: { projectName: string; projectID: string }) => (
                <Link
                    to={`/project-details/projectID=${record?.projectID}`}
                    onClick={() => handleNavigate(record)}
                >
                    <p className="text-[14px] font-normal text-primary-400 cursor-pointer truncate hover:underline focus:underline active:underline">
                        {record?.projectName}
                    </p>
                </Link>
            ),
        },
        {
            title: "Well name",
            dataIndex: "WellName",
            key: "wellName",
            sortable: true,
            width: "11.25%",
        },
        {
            title: "Company name",
            dataIndex: "CompanyName",
            key: "companyName",
            sortable: true,
            width: "11.25%",
        },
        {
            title: "Type",
            dataIndex: "liftTypeName",
            key: "liftTypeName",
            sortable: true,
            width: "8%",
            minwidth: "10rem",
            render: (_: string, record: { caseNameList: any[]; }) => {
                const parentLiftType = record?.caseNameList?.[0]?.liftType;
                const espType = record?.caseNameList?.find((type: any) => type?.liftType === 1);
                const jetType = record?.caseNameList?.find((type: any) => type?.liftType === 2);
                let liftTypeName = <></>;
                if (espType && jetType) {
                    liftTypeName = <>
                        {parentLiftType === 1 ? (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>
                            </>) : (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>
                            </>
                        )}
                    </>;
                } else if (jetType) {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>;
                } else {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>;
                }
                return (
                    <div>
                        {liftTypeName}
                    </div >
                )
            },
        },
        {
            title: "Created on",
            dataIndex: "CreatedOn",
            key: "createdOn",
            sortable: true,
            width: "11.25%",
            render: (_: string, record: { createdOn: string }) => (
                <>
                    {record?.createdOn && moment(record?.createdOn).format("DD MMM YYYY")}
                </>
            ),
        },
        {
            title: "Updated on",
            dataIndex: "UpdatedOn",
            key: "updatedOn",
            sortable: true,
            width: "11.25%",
            render: (_: string, record: { updatedOn: string }) => (
                <>
                    {record?.updatedOn && moment(record?.updatedOn).format("DD MMM YYYY")}
                </>
            ),
        },
        {
            title: "Location",
            dataIndex: "Location",
            key: "Location",
            sortable: true,
            width: "11.25%",
            render: (_: string, record: { country: string; state: string, county: string }) => (
                <>
                    {record?.country ? `${record?.country}` : ""} {record?.state && record?.country ? `, ${record?.state}` : record?.state ? `${record?.state}` : ""} {record?.county && (record?.state || record?.country) ? `, ${record?.county}` : record?.county ? `${record?.county}` : ""}
                </>
            ),
        },
        {
            title: "Account manager",
            dataIndex: "DALRep",
            key: "dalRep",
            sortable: true,
            width: "11.25%",
        },
        {
            title: "Unit system",
            dataIndex: "UnitSystem",
            key: "unitSystem",
            sortable: true,
            width: "11.25%",
        },
        {
            title: " ",
            dataIndex: "icon",
            key: "icon",
            sortable: false,
            width: "5%",
            render: (_: string, record: any, rowIndex: number) => {
                const dropdownOptions = iconDropdownOptions.map((option: any) => {
                    return option;
                });

                return (
                    <div className="flex items-center px-0 py-0">
                        <IconDropdown
                            options={dropdownOptions}
                            onSelect={(selectedValue) => handleDropdown(selectedValue, record)}
                            optionHeading={"Options"}
                            dropdownIcon={true}
                            width="320px"
                            rowIndex={rowIndex}
                        />
                    </div>
                );
            },
        },
    ];

export const OtherDocumentProjects = ({
    handleDropdown,
    iconDropdownOptions,
    handleNavigate,
}: IDocumentProjects) => [
        {
            title: "Project name",
            dataIndex: "ProjectName",
            key: "projectName",
            sortable: true,
            width: "10%",
            render: (_: string, record: { projectName: string; projectID: string }) => (
                <Link to={`/project-details/projectID=${record?.projectID}`} onClick={() => handleNavigate(record)}>
                    <p className="text-[14px] font-normal text-primary-400 cursor-pointer truncate hover:underline focus:underline active:underline">
                        {record?.projectName}
                    </p>
                </Link>
            ),
        },
        {
            title: "Well name",
            dataIndex: "WellName",
            key: "wellName",
            sortable: true,
            width: "8%",
        },
        {
            title: "Company name",
            dataIndex: "CompanyName",
            key: "companyName",
            sortable: true,
            width: "8%",
        },
        {
            title: "Type",
            dataIndex: "liftTypeName",
            key: "liftTypeName",
            sortable: true,
            width: "8%",
            minwidth: "10rem",
            render: (_: string, record: { caseNameList: any[]; }) => {
                const parentLiftType = record?.caseNameList?.[0]?.liftType;
                const espType = record?.caseNameList?.find((type: any) => type?.liftType === 1);
                const jetType = record?.caseNameList?.find((type: any) => type?.liftType === 2);
                let liftTypeName = <></>;
                if (espType && jetType) {
                    liftTypeName = <>
                        {parentLiftType === 1 ? (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>
                            </>) : (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>
                            </>
                        )}
                    </>;
                } else if (jetType) {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>;
                } else {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>;
                }
                return (
                    <div>
                        {liftTypeName}
                    </div >
                )
            },
        },
        {
            title: "Created by",
            dataIndex: "createdBy",
            key: "createdBy",
            sortable: true,
            width: "8%",
        },
        {
            title: "Created on",
            dataIndex: "CreatedOn",
            key: "createdOn",
            sortable: true,
            width: "8%",
            render: (_: string, record: { createdOn: string }) => (
                <>
                    {record?.createdOn && moment(record?.createdOn).format("DD MMM YYYY")}
                </>
            ),
        },
        {
            title: "Updated by",
            dataIndex: "UpdatedBy",
            key: "updatedBy",
            sortable: true,
            width: "8%",
        },
        {
            title: "Updated on",
            dataIndex: "UpdatedOn",
            key: "updatedOn",
            sortable: true,
            width: "10%",
            render: (_: string, record: { updatedOn: string }) => (
                <>
                    {record?.updatedOn && moment(record?.updatedOn).format("DD MMM YYYY")}
                </>
            ),
        },
        {
            title: "Location",
            dataIndex: "Location",
            key: "Location",
            sortable: true,
            width: "10%",
            render: (_: string, record: { country: string; state: string, county: string }) => (
                <>
                    {record?.country ? `${record?.country}` : ""} {record?.state && record?.country ? `, ${record?.state}` : record?.state ? `${record?.state}` : ""} {record?.county && (record?.state || record?.country) ? `, ${record?.county}` : record?.county ? `${record?.county}` : ""}
                </>
            ),
        },
        {
            title: "Account manager",
            dataIndex: "DALRep",
            key: "dalRep",
            sortable: true,
            width: "8%",
        },
        {
            title: "Unit system",
            dataIndex: "UnitSystem",
            key: "unitSystem",
            sortable: true,
            width: "8%",
        },
        {
            title: " ",
            dataIndex: "icon",
            key: "icon",
            sortable: false,
            width: "5%",
            render: (_: string, record: any, rowIndex: number) => {
                const dropdownOptions = iconDropdownOptions.map((option: any) => {
                    return option;
                });

                return (
                    <div className="flex items-center px-0 py-0">
                        <IconDropdown
                            options={dropdownOptions}
                            onSelect={(selectedValue) => handleDropdown(selectedValue, record)}
                            optionHeading={"Options"}
                            dropdownIcon={true}
                            width="320px"
                            rowIndex={rowIndex}
                        />
                    </div>
                );
            },
        },
    ]

export const DocumentProjectsCustomer = ({
    handleNavigate,
}: IDocumentProjectsCustomer) => [
        {
            title: "Well name",
            dataIndex: "WellName",
            key: "wellName",
            sortable: true,
            width: "15.5%",
        },
        {
            title: "Project",
            dataIndex: "ProjectName",
            key: "projectName",
            sortable: true,
            width: "15.5%",
            render: (_: string, record: { projectName: string; projectID: string }) => (
                <Link to={`/project-details/projectID=${record?.projectID}`} onClick={() => handleNavigate(record)}>
                    <p className="text-[14px] font-normal text-primary-400 cursor-pointer truncate hover:underline focus:underline active:underline">
                        {record?.projectName}
                    </p>
                </Link>
            ),
        },
        {
            title: "Type",
            dataIndex: "liftTypeName",
            key: "liftTypeName",
            sortable: true,
            width: "8%",
            minwidth: "10rem",
            render: (_: string, record: { caseNameList: any[]; }) => {
                const parentLiftType = record?.caseNameList?.[0]?.liftType;
                const espType = record?.caseNameList?.find((type: any) => type?.liftType === 1);
                const jetType = record?.caseNameList?.find((type: any) => type?.liftType === 2);
                let liftTypeName = <></>;
                if (espType && jetType) {
                    liftTypeName = <>
                        {parentLiftType === 1 ? (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>
                            </>) : (
                            <>
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>{" "}
                                <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>
                            </>
                        )}
                    </>;
                } else if (jetType) {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">Jet lift</span>;
                } else {
                    liftTypeName = <span className="border text-center border-primary-400 rounded px-2 py-1 text-primary-400">ESP</span>;
                }
                return (
                    <div>
                        {liftTypeName}
                    </div >
                )
            },
        },
        {
            title: "Well API#",
            dataIndex: "WellAPI",
            key: "wellAPI",
            sortable: true,
            width: "15.5%",
        },
        {
            title: "Location",
            dataIndex: "Location",
            key: "Location",
            sortable: true,
            width: "15.5%",
            render: (_: string, record: { country: string; state: string, county: string }) => (
                <>
                    {record?.country ? `${record?.country}` : ""} {record?.state && record?.country ? `, ${record?.state}` : record?.state ? `${record?.state}` : ""} {record?.county && (record?.state || record?.country) ? `, ${record?.county}` : record?.county ? `${record?.county}` : ""}
                </>
            ),
        },
        {
            title: "Pump type",
            dataIndex: "PumpName",
            key: "pumpName",
            sortable: true,
            width: "15.5%"
        },
        {
            title: "Updated on",
            dataIndex: "UpdatedOn",
            key: "updatedOn",
            sortable: true,
            width: "15.5%",
            render: (_: string, record: { updatedOn: string }) => (
                <>
                    {record?.updatedOn && moment(record?.updatedOn).format("DD MMM YYYY")}
                </>
            ),
        },
    ];

export const iconDropdownOptions = [
    {
        id: 1,
        value: "duplicate",
        name: "Duplicate",
        icon: <Copy size={20} />,
        diabled: false,
    },
];

export const archivedDropDownOptions = [
    {
        id: 1,
        value: "duplicate",
        name: "Duplicate",
        icon: <Copy size={20} />,
        diabled: false,
    },
    {
        id: 2,
        value: "remove",
        name: "Remove",
        icon: <Remove size={20} />,
        disabled: false
    }
]
